// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/print/paperconfig/Print.css
// module id = 2017
// module chunks = 0